import gql from 'graphql-tag';
import replaceQueryTemplateVariables from './replaceQueryTemplateVariables';
import addQueryNameToGraphQLDocument from './addQueryNameToGraphQLDocument';
import addDomainContextToGraphQLDocument from './addDomainContextToGraphQLDocument';

export function createGraphQLDocument(query = '') {
	return gql(query);
}

export function getGraphQLDocument(query, templateVars, domainContext, operationName) {
	const updatedQuery = replaceQueryTemplateVariables(query, templateVars);
	return addQueryNameToGraphQLDocument(
		addDomainContextToGraphQLDocument(createGraphQLDocument(updatedQuery), domainContext),
		operationName
	);
}
